 <div  style="overflow: hidden;"
  [ngStyle.sm]="{ 'min-height': '100vh'}"
  [ngStyle.md]="{ 'min-height': '100vh'}"
  [ngStyle.lg]="{ 'min-height': '100vh'}"
  [ngStyle.xl]="{ 'min-height': '100vh'}"
  >
    <br/>
    <div fxLayout="row" style="height: 5vh" ngStyle.xl="height: 10vh">

    </div>

    <div fxLayout="row">

      <div fxLayout="column" fxFlex="5"></div>
      <div fxLayout="column" fxFlex="60"  fxFlex.xs="90">
        <!-- <div fxFlexlayout="row" style="height: 15ch"></div> -->

        <div fxFlexlayout="row">
          <div class="mat-headline-3 auto_margin exo-font">
            <span i18n><b>{{'guest.You look'|translate}}</b>&nbsp;</span>
            <span [@changeDivSize]="[textBlink]"><b>{{ typewriter_display}}</b></span>
            <span class="blinker" [@blinker]="blinker"></span>
          </div>
        </div>
        <div fxFlexlayout="row">
          <div class="mat-headline-3 auto_margin exo-font" i18n><b>{{'guest.when'|translate}}</b></div>
        </div>
        <div fxFlexlayout="row">
          <div class="mat-headline-3 auto_margin exo-font"><b>{{ changing_qoute |translate }}</b></div>
        </div>

        <div fxFlexlayout="row" style="height: 8ch" ngStyle.xl="height: 7ch"></div>


        <div fxFlexlayout="row">
          <div style="color: #9d6020;" class="mat-headline-2 auto_margin exo-font" i18n>
            <b>{{ 'guest.intelligent_integration'| translate }}</b>
          </div>
        </div>
        <div fxFlexlayout="row" style="height: 3ch" ngStyle.xl="height: 6ch"></div>
        <div fxFlexlayout="row">
          <div style="color: #4aaca4;" class="mat-h1 auto_margin exo-font" i18n>
            <b>{{ 'guest.click_click_quote' | translate }}</b>
          </div>
        </div>
        <div fxFlexlayout="row" style="height: 6ch" ngStyle.xl="height: 12ch"></div>

        <div fxFlexlayout="row">
          <div fxLayout="column" fxFlex="40">
            <div class="build_button_div">
              <button class="build_button" (click)="navigateToSignUp()"  type="button">
                <mat-icon>rocket</mat-icon>
                 <span> Build Now </span>
              </button>
            </div>
          </div>
          <div fxLayout="column" fxFlex="60">
          </div>
        </div>

        <div fxFlexlayout="row" style="height: 10ch"></div>

        <div fxLayout="row wrap">
          <div style="padding-right: 10px;">
            <mat-card appearance="outlined" class="card-2 mat-card-custom2">
              <div style="text-align: center;"> 🍀<br>{{ 'guest.Integrate your apps'| translate }} </div>
            </mat-card>
          </div>
          <div style="padding-right: 10px;">
            <mat-card appearance="outlined" class="card-2 mat-card-custom2">
              <div style="text-align: center;"> 💚<br>{{ 'guest.Build your solutions'| translate }} </div>
            </mat-card>
          </div>
          <div style="padding-right: 10px;">
            <mat-card appearance="outlined" class="card-2 mat-card-custom2">
              <div style="text-align: center;"> 🚀<br>{{ 'guest.Automate your processes'| translate }} </div>
            </mat-card>
          </div>
          <div style="padding-right: 10px;">
            <mat-card appearance="outlined" class="card-2 mat-card-custom2">
              <div style="text-align: center;"> 🔥<br>{{ 'guest.Grow your business'| translate }} </div>
            </mat-card>
          </div>

        </div>

        <div fxFlexlayout="row" style="height: -5ch"></div>

      </div>


      <div fxLayout="column" fxHide.xs="true" class="right-background" fxFlex="30" fxFlex.lt-sm="120">
        <!-- <div fxFlexlayout="row" style="height: 5ch" fxHide.lt-sm></div> -->
      </div>

      <div fxLayout="column" fxFlex="5"></div>
    </div>

    <br/>
    <br/>
  </div>
